<!-- Localized -->
<template>
    <card-template
        :item="item"
        :selected="selected"
        :compact="compact"
        class="card-task"
        :class="{
            'card-task--compact': !!compact,
        }"
    >
        <template #content>
            <div class="flex gap-6 justify-between mt-2">
                <div class="property property--description w-2/3">
                    <div class="flex items-center">
                        <span class="font-semibold mr-4">{{ $t('components.dashboard.card.due') }}</span>
                        <div
                            :class="{
                                'bg-red-300': isOverdue,
                                'bg-gray-100': !isOverdue
                            }"
                            class="rounded-lg px-4 py-1 flex items-center mr-4"
                        >
                            <span class="font-semibold mr-2">{{ $t('general.date') }}</span>
                            <span class="text-gray-700">{{ FormatDate(item.target_time, "date") }}</span>
                        </div>
                        <div
                            :class="{
                                'bg-red-300': isOverdue,
                                'bg-gray-100': !isOverdue
                            }"
                            class="bg-gray-100 rounded-lg px-4 py-1 flex items-center mr-4"
                        >
                            <span class="font-semibold mr-2">{{ $t('general.time') }}</span>
                            <span class="text-gray-700">{{ FormatDate(item.target_time, "time") }}</span>
                        </div>
                    </div>
                    <div class="bg-gray-100 rounded-lg px-2 py-0.5 flex mt-2">
                        <span class="font-semibold mr-2 flex-shrink-0">{{ $t('components.dashboard.card.description') }}</span>
                        <span class="text-gray-700" v-html="item.task_text"></span>
                    </div>

                    <div v-if="isMitigationType" class="flex gap-2 mt-2">
                        <p class="bg-gray-100 rounded-lg px-4 py-1 flex items-center">
                            <span class="font-semibold mr-2">{{ $t('components.risk_mitigation.category') }}</span>
                            <span class="text-gray-700">{{ item.risk_mitigation_category }}</span>
                        </p>

                        <p class="bg-gray-100 rounded-lg px-4 py-1 flex items-center ">
                            <span class="font-semibold mr-2">{{ $t('components.risk_mitigation.subcategory') }}</span>
                            <span class="text-gray-700">{{ item.risk_mitigation_sub_category }}</span>
                        </p>

                        <p class="bg-gray-100 rounded-lg px-4 py-1 flex items-center">
                            <span class="font-semibold mr-2">{{ $t('components.risk_mitigation.title') }}</span>
                            <span class="text-gray-700">{{ item.risk_mitigation_title }}</span>
                        </p>
                    </div>
                </div>

                <div v-if="assignees.length > 0" class="flex gap-2 flex-wrap items-start justify-end w-1/3">
                    <div
                        v-for="assignee in assignees"
                        :key="assignee.user_id"
                        class="bg-gray-100 rounded-lg px-4 py-1 flex justify-end items-center gap-1 text-sm"
                    >
                        <span class="font-semibold mr-2">{{ $t('components.sc_journey.assignee') }}</span>
                        <span class="text-gray-700">{{ assignee.user_name }}</span>
                        <Checkbox
                            v-if="assignee.acknowledged"
                            :value="assignee.acknowledged"
                            size="sm"
                            disabled
                        />
                    </div>
                </div>
            </div>
        </template>
        <template #content-compact>
            <div class="font-semibold mr-3">{{ $t('components.dashboard.card.task') }}</div>
            <div class=" property property--date bg-gray-100 rounded-lg  py-0.5 flex ">
            <span class="font-semibold flex-shrink-0">{{ $t('components.dashboard.card.due') }}</span>
            <span class=" text-gray-700 mx-1"  v-if="item.target_time">
                {{ FormatDate(item.target_time,'date') }}, {{ FormatDate(item.target_time,'time') }}
            </span>
        </div>
        </template>
    </card-template>
</template>

<script>
import { mapGetters } from "vuex";
import { DateTime } from "luxon";
import cardTemplate from "./card-base-template.vue";
import Checkbox from "@shared/components/checkbox";

export default {
    name: "card-task",

    components: {
        cardTemplate,
        Checkbox,
    },

    props: {
        item: {
            type: Object,
            required: true,
        },
        selected: {
            type: Boolean,
            required: false,
        },
        compact: {
            type: Boolean,
            required: false,
        },
    },

    computed: {
        ...mapGetters(["getUserDetails"]),

        assignees() {
            return this.item.assinees || [];
        },

        isMitigationType() {
            return Boolean(this.item.risk_mitigation_id);
        },

        isCurrentUserCreator() {
            return this.item?.created_by === this.getUserDetails.id;
        },

        isCurrentUserAssignee() {
            return this.assignees.some(assignee => assignee.user_id === this.getUserDetails.id);
        },

        isOverdue() {
            const today = DateTime.now().startOf('day');
            const givenDate = DateTime.fromISO(this.item?.target_time).startOf('day');
            return today > givenDate;
        },

        dateConfig() {
            return {
                date: "dd MMM yyyy",
                time: "hh:mm a",
            };
        },
    },

    methods: {
        FormatDate(date, type) {
            return DateTime.fromJSDate(new Date(date)).toFormat(this.dateConfig[type]);
        },
    },
};
</script>

<style lang="scss" scoped></style>
